import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiButtonComponent } from './ui-button/ui-button.component';
import { UiCardComponent } from './ui-card/ui-card.component';
import { UiAccordianComponent } from './ui-accordian/ui-accordian.component';
import { AccordianItemDirective } from './ui-accordian/directives/accordian-item.directive';
import { AccordianTitleDirective } from './ui-accordian/directives/accordian-title.directive';
import { AccordianHeaderDirective } from './ui-accordian/directives/accordian-header.directive';
import { AccordianContentDirective } from './ui-accordian/directives/accordian-content.directive';
import { UiModalComponent } from './ui-modal/ui-modal.component';
import { UiTabsComponent } from './ui-tabs/ui-tabs.component';
import { ModalContentDirective } from './ui-modal/directives/modal-content.directive';
import { ModalTriggerDirective } from './ui-modal/directives/modal-trigger.directive';
import { TabsItemDirective } from './ui-tabs/directives/tabs-item.directive';
import { TabsTriggerDirective } from './ui-tabs/directives/tabs-trigger.directive';
import { TabsContentDirective } from './ui-tabs/directives/tabs-content.directive';
import { UiRadioCardComponent } from './ui-radio-card/ui-radio-card.component';
import { UiToastComponent } from './ui-toast/ui-toast.component';
import { ToastService } from './ui-toast/services/ui-toast.service';
import { SnakeToTitlePipe } from './snake-to-title.pipe';
import { UiRichTextEditorComponent } from './ui-rich-text-editor/ui-rich-text-editor.component';

@NgModule({
  imports: [CommonModule, SnakeToTitlePipe],
  providers: [ToastService],
  declarations: [
    UiButtonComponent,
    UiCardComponent,
    UiAccordianComponent,
    AccordianItemDirective,
    AccordianTitleDirective,
    AccordianHeaderDirective,
    AccordianContentDirective,
    UiModalComponent,
    UiTabsComponent,
    ModalContentDirective,
    ModalTriggerDirective,
    TabsItemDirective,
    TabsTriggerDirective,
    TabsContentDirective,
    UiRadioCardComponent,
    UiToastComponent,
    UiRichTextEditorComponent,
  ],
  exports: [
    UiButtonComponent,
    UiCardComponent,
    UiRadioCardComponent,

    UiAccordianComponent,
    AccordianItemDirective,
    AccordianTitleDirective,
    AccordianHeaderDirective,
    AccordianContentDirective,

    UiModalComponent,
    ModalContentDirective,
    ModalTriggerDirective,

    UiTabsComponent,
    TabsItemDirective,
    TabsTriggerDirective,
    TabsContentDirective,

    UiToastComponent,
    SnakeToTitlePipe,
    UiRichTextEditorComponent,
  ],
})
export class UiModule {}
